import { PageStore } from "common/page/store/PageStore";
import React from "react";
import UI from "components/UI";
import { UIButtonProps } from "./UIButton";

export interface UIButtonListOrCloseProps extends UIButtonProps {
  page: PageStore<any>;
  replace?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default UIButtonListOrClose;

function UIButtonListOrClose(props: UIButtonListOrCloseProps) {
  if (props.page.popup == null) {
    return <UI.Button.List className="btn_list" {...props} />;
  }

  return <UI.Button.Close />;
}
